import React from 'react';
import { Link } from 'react-router-dom';
import './PlanCTA.css';

interface PlanCTAProps {
  variant?: 'minimal' | 'inline';
  className?: string;
}

const PlanCTA: React.FC<PlanCTAProps> = ({ variant = 'minimal', className = '' }) => {
  if (variant === 'inline') {
    return (
      <Link to="/planos" className={`plan-cta plan-cta--inline ${className}`.trim()}>
        Escolha seu plano
      </Link>
    );
  }
  return (
    <Link to="/planos" className={`plan-cta plan-cta--minimal ${className}`.trim()}>
      Escolha seu plano
    </Link>
  );
};

export default PlanCTA;
